import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, Shield, ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
const CHECKOUT_URL = 'https://megapack-life-coach.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const faqs = [{
    q: '¿Sirve para cualquier tipo de life coach?',
    a: 'Sí. Las sesiones están organizadas por tema (autoconocimiento, creencias, emociones, hábitos, relaciones, propósito) y funcionan con cualquier metodología: ontológica, PNL, ICF o formación propia.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Descarga inmediata en PDF apenas confirmas la compra. Lo abres en computadora, tablet o celular, y puedes imprimir todo lo que necesites.'
  }, {
    q: '¿Puedo usar el material con mi marca?',
    a: 'Sí. El cuaderno del cliente y los entregables están diseñados para que les pongas tu logo y los uses con tus clientes.'
  }, {
    q: '¿Es un curso? ¿Tengo que estudiar algo?',
    a: 'No. Es material listo para usar. Abres el tomo, eliges la sesión y la das. Cero teoría de relleno.'
  }, {
    q: '¿Sirve si recién me certifiqué y todavía no tengo clientes?',
    a: 'Especialmente. Los bonos de Roleplays y Errores Típicos están pensados exactamente para darte seguridad en tus primeras sesiones.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'Garantía de 7 días con devolución total, sin preguntas.'
  }];
  return <div className="w-full bg-cream" data-id="element-140">
      {/* URGENCY */}
      <section className="py-12 bg-brand-900 text-white text-center px-4" data-id="element-141">
        <div className="max-w-3xl mx-auto" data-id="element-142">
          <div className="inline-block bg-red-500 text-white font-bold px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-143">
            🛑 PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="flex justify-center gap-4 text-4xl md:text-6xl font-black font-mono tracking-tight mb-6" data-id="element-144">
            <div className="flex flex-col" data-id="element-145">
              <span className="text-accent" data-id="element-146">
                {String(timeLeft.hours).padStart(2, '0')}
              </span>
              <span className="text-xs font-sans text-gray-400 uppercase mt-1" data-id="element-147">
                Horas
              </span>
            </div>
            <span className="text-brand-500 pb-6" data-id="element-148">:</span>
            <div className="flex flex-col" data-id="element-149">
              <span className="text-accent" data-id="element-150">
                {String(timeLeft.minutes).padStart(2, '0')}
              </span>
              <span className="text-xs font-sans text-gray-400 uppercase mt-1" data-id="element-151">
                Min
              </span>
            </div>
            <span className="text-brand-500 pb-6" data-id="element-152">:</span>
            <div className="flex flex-col" data-id="element-153">
              <span className="text-accent" data-id="element-154">
                {String(timeLeft.seconds).padStart(2, '0')}
              </span>
              <span className="text-xs font-sans text-gray-400 uppercase mt-1" data-id="element-155">
                Seg
              </span>
            </div>
          </div>
          <p className="text-gray-300 mb-6" data-id="element-156">
            ⚠️ Después sube a $47. No vuelve.
          </p>
          <div className="w-full max-w-md mx-auto bg-brand-800 rounded-full h-3 overflow-hidden" data-id="element-157">
            <div className="bg-accent h-full w-[88%] rounded-full" data-id="element-158"></div>
          </div>
          <p className="text-xs text-gray-400 mt-2" data-id="element-159">
            88% de los cupos al precio de lanzamiento ya reservados
          </p>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-20 px-4 md:px-8 max-w-3xl mx-auto scroll-mt-8" data-id="element-160">
        <div className="text-center mb-12" data-id="element-161">
          <h2 className="text-4xl font-extrabold text-brand-900 mb-4" data-id="element-162">
            Todo incluido, un solo precio
          </h2>
          <p className="text-lg text-gray-600" data-id="element-163">
            Sin planes, sin extras ocultos. Te llevas el sistema completo.
          </p>
        </div>

        <div className="bg-brand-900 rounded-3xl p-8 md:p-10 border-2 border-accent shadow-2xl flex flex-col relative" data-id="element-164">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-165">
            ⭐ TODO INCLUIDO
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 mt-2" data-id="element-166">
            MEGAPACK LIFE COACH
          </h3>
          <p className="text-brand-100 mb-8" data-id="element-167">
            6 Tomos + 5 Bonos + Kit Programas Premium — Todos tus procesos
            resueltos
          </p>
          <div className="mb-8" data-id="element-168">
            <span className="text-gray-400 line-through text-2xl mr-3" data-id="element-169">
              $153
            </span>
            <span className="text-6xl font-black text-white" data-id="element-170">$19.90</span>
            <span className="text-brand-100 font-medium ml-1" data-id="element-171">USD</span>
          </div>
          <ul className="space-y-4 mb-8" data-id="element-172">
            <li className="flex items-start gap-3" data-id="element-173">
              <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-174" />{' '}
              <span className="text-gray-200" data-id="element-175">
                Los 6 Tomos Completos (400+ páginas)
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-176">
              <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-177" />{' '}
              <span className="text-gray-200" data-id="element-178">
                Los 5 Bonos Estratégicos (valor $78)
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-179">
              <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-180" />{' '}
              <span className="text-white font-bold" data-id="element-181">
                Kit Programas Premium completo
              </span>
            </li>
          </ul>
          <div className="bg-brand-800/50 p-4 rounded-xl mb-8 text-sm text-brand-100" data-id="element-182">
            <strong data-id="element-183">Ideal para:</strong> dejar de cobrar por sesión y empezar a
            vender programas cerrados de $300+
          </div>
          <a href={CHECKOUT_URL} className="w-full block text-center bg-accent hover:bg-accent-hover text-white text-lg font-bold py-4 rounded-xl transition-colors shadow-lg shadow-accent/20" data-id="element-184">
            QUIERO MI MEGAPACK AHORA — $19.90
          </a>
          <div className="flex flex-wrap justify-center gap-4 text-xs text-brand-100 font-medium mt-6" data-id="element-185">
            <span className="flex items-center gap-1" data-id="element-186">
              <Shield className="w-4 h-4" data-id="element-187" /> Garantía 7 días
            </span>
            <span data-id="element-188">⚡ Acceso inmediato</span>
            <span data-id="element-189">🔒 Pago 100% seguro</span>
          </div>
        </div>
      </section>

      {/* UPSELL DETAILS */}
      <section className="py-16 bg-white px-4 md:px-8" data-id="element-190">
        <div className="max-w-4xl mx-auto" data-id="element-191">
          <div className="text-center mb-12" data-id="element-192">
            <h3 className="text-3xl font-bold text-brand-900 mb-4" data-id="element-193">
              💼 ¿Qué agrega el Kit "Programas Premium"?
            </h3>
            <p className="text-xl text-gray-600" data-id="element-194">
              De sesiones sueltas a programas que se venden solos.
            </p>
          </div>

          <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm mb-12" data-id="element-195">
            <table className="w-full text-left border-collapse" data-id="element-196">
              <thead data-id="element-197">
                <tr className="bg-gray-50" data-id="element-198">
                  <th className="p-4 border-b border-gray-200 font-bold text-gray-900" data-id="element-199">
                    Situación
                  </th>
                  <th className="p-4 border-b border-gray-200 font-bold text-red-600 bg-red-50/30" data-id="element-200">
                    ❌ Sin Kit
                  </th>
                  <th className="p-4 border-b border-gray-200 font-bold text-brand-600 bg-brand-50/50" data-id="element-201">
                    ✅ Con Kit
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-202">
                <tr data-id="element-203">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-204">
                    El cliente pregunta "¿cuánto cuestan tus sesiones?"
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-205">
                    Cobras por hora y el cliente compara precios
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-206">
                    Vendes un programa cerrado con nombre y resultado
                  </td>
                </tr>
                <tr data-id="element-207">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-208">
                    El cliente termina el primer mes
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-209">
                    Decide sesión a sesión si continúa
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-210">
                    Ya compró un proceso completo de 8-12 semanas
                  </td>
                </tr>
                <tr data-id="element-211">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-212">
                    Necesitas más ingresos
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-213">
                    Tu único camino: más horas
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-214">
                    Coaching grupal: mismo programa, 4-8 personas
                  </td>
                </tr>
                <tr data-id="element-215">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-216">
                    Vender tu servicio
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-217">
                    Explicas qué es el coaching
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-218">
                    Muestras una página de venta profesional
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bg-brand-50 p-6 md:p-8 rounded-2xl border border-brand-100" data-id="element-219">
            <h4 className="font-bold text-brand-900 mb-4 flex items-center gap-2" data-id="element-220">
              <CheckCircle2 className="w-5 h-5 text-brand-600" data-id="element-221" /> EL KIT
              INCLUYE:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-700 font-medium" data-id="element-222">
              <p data-id="element-223">• Programa "Reinvención Personal" (8 sem)</p>
              <p data-id="element-224">• Programa "Del Caos a la Claridad" (12 sem)</p>
              <p data-id="element-225">• Programa corto de entrada (4 sem)</p>
              <p data-id="element-226">• Guía de precios del mercado</p>
              <p data-id="element-227">• Páginas de venta plantilla</p>
              <p data-id="element-228">• Guión de llamada de venta</p>
              <p data-id="element-229">• Kit de coaching grupal</p>
              <p data-id="element-230">• Contratos listos</p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-16 bg-cream px-4" data-id="element-231">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 text-center border-2 border-brand-100 shadow-lg" data-id="element-232">
          <Shield className="w-16 h-16 text-brand-500 mx-auto mb-6" data-id="element-233" />
          <h2 className="text-3xl font-bold text-brand-900 mb-4" data-id="element-234">
            GARANTÍA DE 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-235">
            Abre los tomos. Úsalos en tus sesiones reales. Si en 7 días no es lo
            que esperabas: te devolvemos el 100%, sin formularios y sin
            complicaciones.
          </p>
          <p className="text-sm font-bold text-brand-600 bg-brand-50 inline-block px-4 py-2 rounded-full" data-id="element-236">
            Tasa de devoluciones histórica: menos del 1%.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white px-4 md:px-8" data-id="element-237">
        <div className="max-w-3xl mx-auto" data-id="element-238">
          <h2 className="text-3xl font-bold text-center text-brand-900 mb-12" data-id="element-239">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-240">
            {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-241">
                <button className="w-full px-6 py-4 text-left font-bold text-brand-900 flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" onClick={() => setOpenFaq(openFaq === i ? null : i)} data-id="element-242">
                  {faq.q}
                  {openFaq === i ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-243" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-244" />}
                </button>
                {openFaq === i && <div className="px-6 py-4 bg-white text-gray-600 leading-relaxed" data-id="element-245">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* COST OF NOT HAVING IT */}
      <section className="py-20 bg-brand-900 text-white px-4 md:px-8" data-id="element-246">
        <div className="max-w-4xl mx-auto text-center" data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-248">
            💸 ¿Cuánto cuesta seguir improvisando?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-249">
            <div className="bg-brand-800/50 p-6 rounded-2xl" data-id="element-250">
              <h4 className="text-red-400 font-bold mb-4 flex items-center gap-2" data-id="element-251">
                <XCircle className="w-5 h-5" data-id="element-252" /> Sin MegaPack
              </h4>
              <ul className="space-y-4 text-gray-300" data-id="element-253">
                <li data-id="element-254">2 horas de preparación por cliente cada semana</li>
                <li data-id="element-255">Buscar ejercicios sueltos en Google y YouTube</li>
                <li data-id="element-256">Cliente que no percibe un método</li>
                <li data-id="element-257">Inseguridad antes de cada sesión</li>
              </ul>
            </div>
            <div className="bg-brand-800 p-6 rounded-2xl border border-brand-700" data-id="element-258">
              <h4 className="text-brand-300 font-bold mb-4 flex items-center gap-2" data-id="element-259">
                <ArrowRight className="w-5 h-5" data-id="element-260" /> Costo real
              </h4>
              <ul className="space-y-4 text-white font-medium" data-id="element-261">
                <li data-id="element-262">100+ horas al año de trabajo no pago</li>
                <li data-id="element-263">Sesiones sin coherencia entre sí</li>
                <li data-id="element-264">Abandona al 2do mes — pierdes $100-300 por cliente</li>
                <li data-id="element-265">Cobras menos de lo que vales</li>
              </ul>
            </div>
          </div>

          <p className="text-2xl font-serif italic text-accent mb-12" data-id="element-266">
            "Tu próxima sesión puede ser la mejor que has dado."
          </p>

          <div className="bg-white text-brand-900 p-8 md:p-12 rounded-3xl max-w-2xl mx-auto shadow-2xl" data-id="element-267">
            <h3 className="text-2xl font-bold mb-6" data-id="element-268">
              Deja de improvisar. Empieza a coachear con un sistema.
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-269">
              SESIONES. HERRAMIENTAS. GUIONES. SEGUIMIENTO. PROGRAMAS. Todo
              resuelto.
            </p>
            <a href={CHECKOUT_URL} className="w-full bg-brand-600 hover:bg-brand-700 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1 block mb-4" data-id="element-270">
              SÍ, QUIERO MI MEGAPACK LIFE COACH
            </a>
            <div className="flex justify-center items-center gap-2 text-sm text-gray-500" data-id="element-271">
              <Shield className="w-4 h-4" data-id="element-272" /> Garantía de 7 días
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-brand-950 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-273">
        <div className="max-w-4xl mx-auto" data-id="element-274">
          <p className="font-bold text-white mb-2" data-id="element-275">MEGAPACK LIFE COACH™</p>
          <p className="mb-8 max-w-md mx-auto" data-id="element-276">
            El sistema #1 de sesiones listas para life coaches de habla hispana.
            Porque coachear no debería empezar con miedo la noche anterior.
          </p>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-277">
            <a href="#" className="hover:text-white transition-colors" data-id="element-278">
              soporte@tudominio.com
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-279">
              @tuinstagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-280">
              Términos y condiciones
            </a>
          </div>
        </div>
      </footer>
    </div>;
}